
import { useEffect, useState } from "react";
import { Alert, Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenProductPartidaArancelariaPubSub, OpenProductPartidaArancelariaPubSubPayload } from "@utils/pubsubs/PubSub";
import { ProductPartidaArancelariaDataType } from "@/formTypes/ProductPartidaArancelariaDataType";
import ChangeProductPartidaArancelariaForm from "@components/forms/ChangeProductPartidaArancelariaForm";
import { useAppDispatch } from "@/store/hooks";
import { setProductPropertyData } from "@/store/slices/eDocumentSlides";

type SetProductPartidaArancelariaOffCanvasProps = {
} & DefaultOffCanvasProps

const SetProductPartidaArancelariaOffCanvas = (props: SetProductPartidaArancelariaOffCanvasProps) => {
    const { btnColor = "primary", className } = props;
    const [defaultData, setDefaultData] = useState<ProductPartidaArancelariaDataType>({} as ProductPartidaArancelariaDataType);
    const [isOpen, setOpen] = useState(false);
    const dispatch = useAppDispatch()


    useEffect(() => {
        const unsubscribe = OpenProductPartidaArancelariaPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenProductPartidaArancelariaPubSubPayload) => {
        const { openOffCanvas = false } = payload;
        setOpen(openOffCanvas);
        setDefaultData({
            productId: payload.productLineId,
            partidaArancelaria: payload.partidaArancelaria
        });
    }

    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const triggerPartidaArancelariaChanged = (partidaChange?: ProductPartidaArancelariaDataType) => {
        setOpen(false);
        dispatch(setProductPropertyData({
            property: "partidaArancelaria",
            value: partidaChange?.partidaArancelaria,
            id: `${partidaChange?.productId}`
        }))
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >

                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Ajuste de Partida Arancelaria
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <Alert className="mb-4" color="warning">
                            La partida arancelaria es obligatoria para mercancia de exportacion
                        </Alert>
                        <ChangeProductPartidaArancelariaForm
                            defaultData={defaultData}
                            onPartidaChanged={triggerPartidaArancelariaChanged}
                        />
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
        </>
    );
}
export default SetProductPartidaArancelariaOffCanvas;
